import { ButtonGroup } from '@material-ui/core'
import { Autorenew } from '@material-ui/icons'
import React from 'react'
import cloneOrCreateElement from './cloneOrCreateElement'
import Button from './customized-mui-components/Button'

export const ButtonWithRecurringJob = ({ ...props }) => {
  const { label, mainAction, onClick, recurringAction, ...rest } = props

  const DefaultAction = ({ ...actionProps }) => {
    const { asRecurringJob, ...actionRest } = actionProps

    return (
      <Button
        {...actionRest}
        variant="contained"
        label={asRecurringJob ? label : ''}
        onClick={onClick}
        useSmallVersionBreakpoint={false}
        size="small"
      >
        {asRecurringJob ? <Autorenew /> : undefined}
      </Button>
    )
  }

  return (
    <ButtonGroup
      style={{ verticalAlign: 'middle' }}
      variant="contained"
      color="primary"
      size="small"
    >
      {mainAction ? cloneOrCreateElement(mainAction, rest) : <DefaultAction />}
      {recurringAction ? (
        cloneOrCreateElement(recurringAction, rest)
      ) : (
        <DefaultAction asRecurringJob />
      )}
    </ButtonGroup>
  )
}
